module.exports = __webpack_public_path__ + "img/Apricot.72682286.svg";